import { createAction, props } from '@ngrx/store';
import { Invitation } from '../../../../models/Invitation';

const INVITATIONS = 'Invitations';

export const getInvitations = createAction(`[${INVITATIONS}] Get Invitations`);
export const getInvitationsSuccess = createAction(`[${INVITATIONS}] Get Invitations Success`, props<{ invitations: Invitation[] }>());
export const getInvitationsFailure = createAction(`[${INVITATIONS}] Get Invitations Failure`, props<{ errorMessage: string }>());

// Actions for handling real-time updates
export const addInvitation = createAction(`[${INVITATIONS}] Add Invitation`, props<{ invitation: Invitation }>());
export const updateInvitation = createAction(`[${INVITATIONS}] Update Invitation`, props<{ invitation: Invitation }>());
export const removeInvitation = createAction(`[${INVITATIONS}] Remove Invitation`, props<{ id: number }>());
